(function(){
  function init(){
    var box=document.querySelector('.rx-collection-filters');
    if(!box)return;
    var head=box.querySelector('#rx-category-filter-title');
    if(!head)return;
    if(head.textContent.trim()==='Categoriile')head.textContent='Categorii';
    if(head.dataset.rxBound)return;
    head.dataset.rxBound='1';
    head.setAttribute('role','button');
    head.setAttribute('tabindex','0');
    head.setAttribute('aria-expanded','false');
    function toggle(){
      if(window.innerWidth>900)return;
      var on=box.classList.toggle('is-open');
      head.setAttribute('aria-expanded',on?'true':'false');
    }
    head.addEventListener('click',toggle);
    head.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();toggle()}});
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();